import { render } from "./BonusItemSingle.vue?vue&type=template&id=6fb1794c&scoped=true"
import script from "./BonusItemSingle.vue?vue&type=script&lang=js"
export * from "./BonusItemSingle.vue?vue&type=script&lang=js"

import "./BonusItemSingle.vue?vue&type=style&index=0&id=6fb1794c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb1794c"]])

export default __exports__